import { Component, EventEmitter, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { buttonTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { FilterDTO } from 'src/app/shared/Models/PartyModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { activityStatus } from '../../../shared/constants/commonenums';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';

@Component({
    selector: 'app-activity-filter',
    templateUrl: './activity-filter.component.html',
    styleUrls: ['./activity-filter.component.scss'],
    standalone: false
})
export class ActivityFilterComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() filterData = new EventEmitter<[]>();
  @Output() resetData = new EventEmitter<boolean>();
  reservationConfig: FieldConfig[];
  membershipConfig: FieldConfig[];
  previousButton: ButtonValue;
  nextButton: ButtonValue;
  SelectedActivityData: any;
  locationList: any[];
  instructorList: any[];
  daysCount = [];
  hasMembershipValue: boolean = false;
  picker: any;
  filteredSessions: any = [];
  membershipValid: boolean;
  membershipStatus: string ;
  inputvalidation : boolean = false;
  days = [{ id: 1, day: 'Monday' }, { id: 2, day: 'Tuesday' },
  { id: 3, day: 'Wednesday' }, { id: 4, day: 'Thursday' },
  { id: 5, day: 'Friday' }, { id: 6, day: 'Saturday' }, { id: 0, day: 'Sunday' }];
  @ViewChild('reservationConfigForm', { static: true }) reservationConfigForm: DynamicFormComponent;
  @ViewChild('coverTypeForm', { static: true }) coverTypeForm: DynamicFormComponent;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  Subscriptions: Subscription = new Subscription();
  constructor(private ts: TranslateService, public activityService: GuestService, public dynamicFormService: DynamicFormService) {
    this.Subscriptions.add(this.activityService.filterAvailabilities.subscribe(data => {
      if(data === true && this.filteredSessions && this.filteredSessions.length > 0) {
      this.getFilterValues();
      }
     }))
  }

  ngOnInit(): void {
    this.locationList = this.activityService.LocationList;
    if (this.activityService.InstructorList) {
      this.instructorList = _.orderBy(this.activityService.InstructorList, ['Name'], ['asc']);
    }
    this.createReservationConfig();
    this.createActionButtons();
  }
  ngAfterViewInit() {
    this.components.forEach(x => {
      x.form.valueChanges.subscribe(value => {
        if(value.StartDate){ 
          this.setMindate(value);
        }
        if(value.MembershipId){
          this.inputvalidation = this.dynamicFormService.inputvalidation(value.MembershipId);
        }
        if(!this.inputvalidation){
          this.nextButton.disbaledproperity = false;
        }else{
          this.nextButton.disbaledproperity = true;
        }
      })
    });
  }
  setMindate(value){
    this.reservationConfig[4].minDate = value.StartDate;
    if(value.EndDate || value.EndDate !== null ){
      if(value.EndDate < value.StartDate){
        this.reservationConfig[4].value = value.StartDate;
      }
    }
  }
  createReservationConfig() {
    this.membershipConfig = [{
      type: 'input',
      label: this.ts.instant('MembershipID'),
      name: 'MembershipId',
      inputType: 'text',
      class: 'guest-details__first-name',
      showErrorText: true,
      appearance: true,
      isFormArray: false,
      validation: [Validators.required],
      hide: this.activityService.operation == operationType.edit,
    }];
    this.reservationConfig = [

      {
        type: 'select',
        name: 'InProgress',
        placeholder: '',
        options: [{ id: 0, value: activityStatus[0] }, { id: 1, value: activityStatus[1] }, { id: 2, value: activityStatus[2] }],
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('ActivityDates'),
        class: "reservation-details__party-size",
        validation: [Validators.required],
        value: 0
      },
      {
        type: 'select',
        name: 'LocationId',
        placeholder: '',
        options: this.locationList.map(x => ({ id: x.Id, value: x.Name })),
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('SelectaLocation'),
        class: "reservation-details__party-size",
        validation: [Validators.required],
      },
      {
        type: 'select',
        name: 'InstructorId',
        placeholder: '',
        options: this.instructorList.map(x => ({ id: x.Id, value: x.Name + ' ' + (x.LastName || '') })),
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('SelectaInstructor'),
        class: "reservation-details__party-size",
        validation: [Validators.required],
      },
      {
        type: 'date',
        name: 'StartDate',
        placeholder: '',
        minDate: new Date(),
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('FromDate'),
        class: "reservation-details__date",
        validation: [Validators.required],
      },
      {
        type: 'date',
        name: 'EndDate',
        placeholder: '',
        minDate: new Date(),
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('ToDate'),
        class: "reservation-details__date",
        validation: [Validators.required],
      },
      {
        type: 'time',
        name: 'StartTime',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('StartTime'),
        class: "reservation-details__date",
        validation: [Validators.required],
      },
      {
        type: 'time',
        name: 'EndTime',
        placeholder: '',
        appearance: true,
        isFormArray: false,
        label: this.ts.instant('EndTime'),
        class: "reservation-details__date",
        validation: [Validators.required],
      },
    ];
  }
  createActionButtons() {
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('clearAll'),
      customclass: 'reservation-details__previous-btn',
    };
    this.nextButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('apply'),
      customclass: 'guest-details__confirm-btn',
      disbaledproperity: true
    };
  }
  getFilterValues() {
    const FilterObj = {} as FilterDTO;
    const [memberFormGroup, filterFormGroup] = this.components;
    FilterObj.MembershipId = memberFormGroup.form.get("MembershipId").value;
    if(FilterObj.MembershipId){
      this.hasMembershipValue = FilterObj.MembershipId.length > 0;
    }
    FilterObj.InProgress = filterFormGroup.form.get("InProgress").value;
    FilterObj.LocationId = filterFormGroup.form.get("LocationId").value;
    FilterObj.InstructorId = filterFormGroup.form.get("InstructorId").value;
    FilterObj.StartDate = filterFormGroup.form.get("StartDate").value;
    FilterObj.EndDate = filterFormGroup.form.get("EndDate").value;
    FilterObj.StartTime = filterFormGroup.form.get("StartTime").value;
    FilterObj.EndTime = filterFormGroup.form.get("EndTime").value;
    this.filterPayLoad(FilterObj)
  }
  filterPayLoad(filterObj) {
    const requestedObject = {
      MembershipId: filterObj.MembershipId,
      ActivityState: filterObj.InProgress,
      LocationId: filterObj.LocationId,
      InstructorId: filterObj.InstructorId,
      StartDate: filterObj.StartDate === undefined ? null : new Date(filterObj.StartDate).toDateString() ,//(moment(filterObj.StartDate).format()).split("+")[0],
      EndDate: filterObj.EndDate === undefined ? null :new Date(filterObj.EndDate).toDateString() ,//(moment(filterObj.EndDate).format()).split("+")[0],
      StartTime: filterObj.StartTime,
      EndTime: filterObj.EndTime,
      filteredDays: this.daysCount
    }
    for (let [key, value] of Object.entries(requestedObject)) {
      if(value === undefined || value === '' || value === 'Invalid date')
      {
        requestedObject[key] = null;
      }
  }
    this.Subscriptions.add(this.activityService.GetFilterValues(requestedObject).subscribe(response => {
      const memberShipdetail = response.Payload.Contact;
      if(this.hasMembershipValue && response.Payload.Contact && response.Payload.Contact.MembershipType){
        this.membershipValid = true;
      }else{
        this.membershipValid = false;
      }
      if (response.Payload.Contact) {
        let editPartyData = {
          Contact: {},
        };
        const memberType = this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(allocation => allocation.AllocationTypeName.trim().toLocaleLowerCase() === memberShipdetail.MembershipType.trim().toLocaleLowerCase());
        const guestObject = {
          FirstName: memberShipdetail.FName,
          LastName: memberShipdetail.LName,
          EmailAddress:  memberShipdetail.Email,
          PhoneNumber: memberShipdetail.PhoneNumber,
          CountryId: this.activityService.getCountryId(memberShipdetail.PhoneCode),
          PIILastUsedDate: null,
          EmailAddress2: memberShipdetail.EmailList ? memberShipdetail.EmailList[1]?.EmailId : null,
          PhoneNumber2:memberShipdetail.PhoneList ? memberShipdetail.PhoneList[1]?.PhoneNumber: memberShipdetail.PhoneNumber,
          Birthday: memberShipdetail.Dob,
          ContactCustomFields: [],
          Notes: [],
          VisitStats: [],
          MarketingOptedIn: null,
          memberShipId: memberShipdetail.CardNo,
          MembershipType: memberShipdetail.MembershipType,
          MemberActive: memberShipdetail.MembershipStatus?.toLowerCase() === "active"
        }
        this.membershipStatus = memberShipdetail.MembershipStatus;
        editPartyData.Contact = guestObject;
        this.activityService.editPartyData$.next(editPartyData);
        this.activityService.selectedGuest = guestObject;
        this.activityService.selectedGuest.TrackMembershipNumber = memberShipdetail.CardNo; //
        this.activityService.membershipId = guestObject.MemberActive ? this.activityService.restaurantWidgetSettings$.value.AllocationMappings.find(x => x.AllocationTypeName.trim().toLowerCase() == response.Payload.Contact.MembershipType.trim().toLowerCase())?.AllocationTypeId : null;
      } else {
        this.activityService.membershipId = null;
      }
      const lessons = response.Payload.Lessons;
      lessons.forEach(lesson => {
        lesson.AvailableSlots = this.activityService.restaurantWidgetSettings$.value.AvailableSpecialMeals?.find(x => x.Id == lesson.Id)?.AvailableSlots;
        lesson.ImageData = this.activityService.restaurantWidgetSettings$.value.AvailableSpecialMeals?.find(x => x.Id == lesson.Id)?.ImageData;
      });
      this.filteredSessions = response.Payload.Lessons;
      this.filterData.emit(response.Payload.Lessons)
    }))
  }
  getFormValue(formObj, fieldName) {
    return formObj && formObj.form.get(fieldName)?.value;
  }
  getAvailableDays(id) {
    let daysArr = [];
    if (this.daysCount.includes(id)) {
      _.map(this.daysCount, (day) => {
        if (day !== id) {
          daysArr.push(day)
        }
      });
      this.daysCount = daysArr;
    } else {
      this.daysCount.push(id);
    }
    this.nextButton.disbaledproperity = false;
  }
  resetFilter() {
    const [memberFormGroup, filterFormGroup] = this.components;
    memberFormGroup.form.reset("MembershipId");
    filterFormGroup.form.reset("InProgress");
    filterFormGroup.form.reset("LocationId");
    filterFormGroup.form.reset("InstructorId");
    filterFormGroup.form.reset("StartDate");
    filterFormGroup.form.reset("EndDate");
    filterFormGroup.form.reset("StartTime");
    filterFormGroup.form.reset("EndTime");
    this.daysCount = [];
    this.activityService.selectedGuest  = null;
    this. hasMembershipValue = false;
    this.activityService.editPartyData$.next(null);
    this.activityService.membershipId = null;
    this.resetData.emit(true);
    this.createReservationConfig();
  }
  checkAvailability(id) {
    return this.daysCount.includes(id) ? true : false;
  }
  checkAvailableDate(id) {
    if (this.daysCount.includes(id)) {
      return true;
    }
    else {
      false;
    }
  }
  ngOnDestroy(): void {
    if (this.Subscriptions) { this.Subscriptions.unsubscribe(); }
  }
}
